import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { colors } from '@/theme/colors';

function PermissionPlaceholder({ name, permission, body }) {
  return (
    <Paper data-testid="permissionPlaceholder">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          gap: '16px',
        }}
      >
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          size="3x"
          width={30}
          style={{ color: colors.warning.main }}
        />
        <Typography variant="h5" align="center">
          You do not have permission to view {name}.
        </Typography>
        {permission ? (
          <Typography variant="body1" align="center">
            {`You are missing the permission "${permission}".`}
          </Typography>
        ) : null}
        {body ? (
          <Typography variant="body1" align="center">
            {body}
          </Typography>
        ) : null}

        <Typography variant="body1" align="center">
          If you believe this is an error, please contact product support.
        </Typography>
      </Box>
    </Paper>
  );
}

PermissionPlaceholder.propTypes = {
  name: PropTypes.string.isRequired,
  permission: PropTypes.string.isRequired,
};

export default PermissionPlaceholder;
